// MUI imports
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import RadioGroup from '@mui/material/RadioGroup';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';

function OpportunityDescriptionPane(props) {

    const { description, setDescription } = props;

    return (
        <Box>
            <TextField
                InputLabelProps={{ shrink: true }}
                fullWidth
                label={'Team\'s Notes'}
                margin='normal'
                onChange={e => setDescription({ ...description, freeText: e.target.value })}
                value={(description || {}).freeText || ''} 
                placeholder={'Write what your team should know when viewing this opportunity...'}
            />
            <Typography component={Box} variant='caption'>
            </Typography>
        </Box>
    )
}

export default OpportunityDescriptionPane;
